import { Injectable } from '@angular/core';
import { TimeServiceProvider } from '@services/helpers/time-service/time.service';
import { ValidationProvider } from '@services/helpers/validation.service';
import { MessageService } from '@services/helpers/message-service/message.service';

@Injectable()
export class AmbassadorService {
	constructor(
		private timeService: TimeServiceProvider,
		private validationService: ValidationProvider,
		private messageService: MessageService
	) {}

	public validateAmbassador(ambassador) {
		let dateStart, dateEnd;
		const validAmbassador = JSON.parse(
			JSON.stringify(ambassador),
			this.timeService.parseDateFromJSON
		);

		if (this.validationService.isStringEmpty(ambassador.firstName)) {
			this.messageService.showToaster(
				'e_2',
				'general',
				'Ambassador code is empty'
			);
			return false;
		}

		dateStart = this.timeService.getDateInFormat(
			validAmbassador.startDate,
			'date'
		);
		dateEnd = this.timeService.getDateInFormat(validAmbassador.endDate, 'date');

		const isCorrectDate = this.timeService.compareDates(dateEnd, dateStart);

		if (isCorrectDate) {
			this.messageService.showToaster(
				'e_2',
				'general',
				'The start date must be before the end date.'
			);
			return false;
		}

		validAmbassador.startDate = dateStart;
		validAmbassador.endDate = dateEnd;

		return validAmbassador;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/services/admin/ambassadors/ambassador.service.ts